<!-- eslint-disable vue/multi-word-component-names -->
<script>
import Vue from 'vue'
import numeral from 'numeral'
import moment from 'moment'
import { toCapitalCase } from '@/utils/transformCase'

Vue.filter('numberFormat', function (value) {
  return numeral(value).format('0,0')
})
Vue.filter('decimalFormat', function (value) {
  return numeral(value).format('0,0.00')
})

Vue.filter('shortFormat', function (value) {
  if (value >= 1000) {
    return numeral(value).format('0.0a').toUpperCase()
  } else {
    return numeral(value).format('0,0')
  }
})

Vue.filter('DateFormat', function (value, format) {
  if (value) {
    return moment(value).format(format)
  } else {
    return '-'
  }
})

Vue.filter('DateDistance', function (value) {
  return moment.duration(moment().diff(moment(value))).distance({ includeSeconds: false })
})

Vue.filter('capitalize', function (value) {
  return toCapitalCase(value)
})

export default {}
</script>



// WEBPACK FOOTER //
// src/filters.vue